import { Component } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  selector: 'miq-text-input',
  templateUrl: './text-input.component.html',
  standalone: false,
})
export class AdvancedTextInputComponent extends AbstractAdvancedInput {}
